import BannerEdit from "./edit.vue";
import BannerList from './list.vue'
import BannerInfo from './info.vue'
let a = Object.assign({BannerEdit, BannerList, BannerInfo}, {})
export default a;
